var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgChatEmojii = function SvgChatEmojii(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'currentColor',
    d: "M7.502 12.004a4.507 4.507 0 0 1 4.5-4.5 4.506 4.506 0 0 1 4.5 4.5 4.507 4.507 0 0 1-4.5 4.5 4.51 4.51 0 0 1-4.5-4.5m.817 0a3.686 3.686 0 0 0 3.683 3.686 3.686 3.686 0 0 0 3.684-3.686 3.68 3.68 0 0 0-3.684-3.674 3.68 3.68 0 0 0-3.684 3.674zm.767.855a.38.38 0 0 1 .074-.346.42.42 0 0 1 .334-.154h5.017a.45.45 0 0 1 .353.166.34.34 0 0 1 .056.334 3.04 3.04 0 0 1-2.917 1.943 3.04 3.04 0 0 1-2.918-1.946zm2.916 1.168a2.28 2.28 0 0 0 1.846-.9h-3.69a2.28 2.28 0 0 0 1.844.897z"
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgChatEmojii);
export default ForwardRef;